import { render } from "./MessageItem.vue?vue&type=template&id=05591cc0&scoped=true&ts=true"
import script from "./MessageItem.vue?vue&type=script&lang=ts"
export * from "./MessageItem.vue?vue&type=script&lang=ts"

import "./MessageItem.vue?vue&type=style&index=0&id=05591cc0&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05591cc0"]])

export default __exports__